module.exports = __webpack_public_path__ + "img/enjoy.9a994fb1.jpg";